import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  FormGroup,
  FormControl,
  InputGroup,
  Glyphicon,
  Modal,
  ControlLabel,
  DropdownButton,
  MenuItem,
  ButtonGroup,
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import { get_email_tempelate_list, get_email_tempelate_details, testTemplate } from "../../../redux/actions/emailActions";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import "../../../style/listPage.scss";

import ReactHtmlParser from 'react-html-parser';
import {aclUtil} from "../../util"

const history = createBrowserHistory();
let isLoading="false";
class EmailTempelateList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'EMAIL_TEMPLATE',
      emailTempelateList: [],
      totalRecords: 0,
      perPage: 0,
      currentPage: 1,
      limit:25,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      path: ["Home", "Email Tempelate"],
      links: ['home','emailTemplate'],
      show: false,
      titleSortIcon: "",
      direction: "",
      orderBy: "",
      searchString: "",
      emailPopUpData: '',
      emailPopUpStatus: false,
      email: "",
      popUpData: "",
      popUpStatus: false,
     mailresponseset: "",
     emaisendbtn:false,
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  openPopup = (e) => {
    let id = (e.target.attributes.getNamedItem('data-key').value);
    let lang = (e.target.attributes.getNamedItem('data-lang').value);
    this.setState({lang: lang});
    this.props.get_email_tempelate_details(id);
  }

  closePopup = (e) => {
    this.setState({
      popUpData: '',
      popUpStatus: false,
      lang: '',
    })
  }

  handleEmailChange = (e) => {
    this.setState({email: e.target.value, emailError:""});
  }

  handleEmailExecute = (e) => {
    if(this.state.email.length === 0){    
      this.setState({emailError:"red"});
      return false;
    }
    this.setState({ emaisendbtn: true });
   
    let constData = {
      templateID : this.state.emailPopUpData,
      email :  this.state.email,
    }

     isLoading = "true";
    this.props.testTemplate(constData);

  }

  emailOpenPopup = (e) => {

    let data = e.target.attributes.getNamedItem('data-key').value;
          this.setState({ mailresponseset: false });
                this.setState({ emaisendbtn: false });
  
    this.setState({
      emailPopUpData: data,
      emailPopUpStatus: true,
    });
  }

  emailClosePopup = (e) => {
    this.setState({
      emailPopUpData: '',
      emailPopUpStatus: false,
      email: '',
    })
  }

  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-down",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.get_email_tempelate_list({
      orderBy: orderBy,
      direction: direction,
      page: this.state.currentPage,
      limit: this.state.limit,
      multi_lang: 'no',
    });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      if(siteData.multi_lang){
        this.setState({
          multi_lang: siteData.multi_lang
        });
      }
    }
    this.handleDismiss();
    this.props.clearAlert();
    this.props.get_email_tempelate_list({ page: this.state.currentPage,limit: this.state.limit });
  }
  handlePageChange = page => {
    this.setState({
      currentPage: page
    });
    if (this.state.direction !== "" && this.state.orderBy !== "") {
      this.props.get_email_tempelate_list({
        page: page,
        orderBy: this.state.orderBy,
        direction: this.state.direction,
        limit: this.state.limit
      });
    } else if (this.state.searchString !== "") {
      this.props.get_email_tempelate_list({
        page: page,
        search: this.state.searchString,
        limit: this.state.limit
      });
    } else {
      this.props.get_email_tempelate_list({ page: page, limit: this.state.limit });
    }
  };

  handleSearch = () => e => {
    const searchString = e.target.value;
    if (searchString.length > 0) {
      this.props.get_email_tempelate_list({
        search: searchString,
        page: this.state.currentPage
      });
    } else {
      this.props.get_email_tempelate_list({ page: this.state.currentPage,limit: this.state.limit });
    }
    this.setState({ searchString: searchString });
  };

  componentWillReceiveProps(nextProps) {
    console.log(nextProps);
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    if (this.props.emailTempelateDetails !== nextProps.emailTempelateDetails) {
      this.setState({
        popUpData: (this.state.lang == 'en') ? nextProps.emailTempelateDetails.content : nextProps.emailTempelateDetails.french_content,
        popUpStatus: true,
      })
    }

    if (
      this.props.emailTempelatesList !== nextProps.emailTempelatesList &&
      !isEmpty(nextProps.emailTempelatesList)
    ) {
      const setPageCount =
        nextProps.emailTempelatesList.total /
        nextProps.emailTempelatesList.per_page;
      this.setState({
        emailTempelateList: nextProps.emailTempelatesList.data,
        totalRecords: nextProps.emailTempelatesList.total,
        perPage: nextProps.emailTempelatesList.per_page,
        pageCount: setPageCount
      });
    }
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ alert: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if(this.props.mailResponse !== nextProps.mailResponse){
      if(nextProps.mailResponse){
    // this.props.renderAlert("success", "Email Send Successfully");
        this.setState({ mailresponseset: true });

        this.setState({ alert: false });
            isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.emailClosePopup();
        this.props.renderAlert("success", nextProps.mailResponse.message);
      }
    }

    if (nextProps.message) {
      this.setState({ alertMessage: nextProps.message });
    }
    if (nextProps.alertType) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let emailRow;
    if (!isEmpty(this.props.emailTempelatesList)) {
      if (this.props.emailTempelatesList.data) {
        emailRow = this.props.emailTempelatesList.data.map((email, index) => (
          <tr key={email.templateID}>
            <td>{email.title}</td>
            <td style={{ textTransform: "capitalize" }}>{email.status}</td>
            <td>
              <ButtonGroup>
                  <DropdownButton title="Action" id="bg-nested-dropdown">
                     <MenuItem eventKey={Math.random()} data-lang="en" data-key={email.templateID} onClick={this.openPopup}><i className="glyphicon glyphicon-eye-open"></i> Preview English</MenuItem>
                     {(this.state.multi_lang == "yes") ? <MenuItem eventKey={Math.random()} data-lang="fr" data-key={email.templateID} onClick={this.openPopup}><i className="glyphicon glyphicon-eye-open"></i> Preview French</MenuItem> : ''}
                    {aclUtil.checkACL('EDIT_EMAIL_TEMPLATE') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/updateEmailTemplate/${email.templateID}`)}><i className="glyphicon glyphicon-pencil"></i> Edit</MenuItem>):("")}
                     <MenuItem eventKey={Math.random()} data-key={email.templateID} onClick={this.emailOpenPopup}><i className="glyphicon glyphicon-send"></i> Test Email</MenuItem>
                  </DropdownButton>
              </ButtonGroup>
            </td>
          </tr>
        ));
      }
    }

    return (
      <div className="col-lg-12 add-sub-admin">

        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="list-page">

          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Email-Template List</header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="clearfix" />
              <div className="row m-t-15">
                <div className="col-lg-4 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" onKeyUp={this.handleSearch()} />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
              </div>
              {this.props.emailTempelatesList &&
              this.props.emailTempelatesList.data &&
              this.props.emailTempelatesList.data.length > 0 ? (
                <div className="col-lg-12">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th onClick={this.handleSort("title")}>
                          Title<span
                            className={this.state.titleSortIcon}
                            aria-hidden="true"
                          />
                        </th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>{emailRow}</tbody>
                  </table>
                  <div className="text-center">
                    <Pagination
                      total={totalRecords}
                      limit={perPage}
                      pageCount={5}
                      currentPage={currentPage}
                    >
                      {({
                        pages,
                        currentPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps
                      }) => (
                        <div className="pagination">
                          <button
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map(page => {
                            let activePage = null;
                            if (currentPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666"
                              };
                            }
                            return (
                              <button
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12">
                  Email Templates are not available
                </div>
              )}
              <div className="clearfix" />
            </div>
          </div>
        </div>
        <Modal show={this.state.emailPopUpStatus} onHide={this.emailClosePopup}>
          <Modal.Header closeButton>
            <Modal.Title>Send Test Email</Modal.Title>
          </Modal.Header>
          <Modal.Body>
             <FormGroup>
              {this.state.mailresponseset ? (
                <div class="alert alert-success">Email Send Successfully.</div>
              ) : (
                ""
              )}
                  <ControlLabel>Enter an email address below to send a test email. Useful if you want to preview what the email will look like in your customers inbox.</ControlLabel>
                  <FormControl
                    type="email"
                    value={this.state.email}
                    placeholder="Enter Email"
                    name="email"
                    onChange={this.handleEmailChange}
                    style={{borderColor:this.state.emailError}}
                  />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" disabled={this.state.emaisendbtn} onClick={this.handleEmailExecute}>Send Mail</Button>
            <Button bsStyle="danger" onClick={this.emailClosePopup}>Close</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.popUpStatus} onHide={this.closePopup}>
          <Modal.Header closeButton>
            <Modal.Title>Email Template Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {ReactHtmlParser(this.state.popUpData)}
          </Modal.Body>
          <Modal.Footer>
           {/* <Button bsStyle="success" onClick={this.handleExecute.bind(this)}>Execute</Button>*/}
            <Button bsStyle="danger" onClick={this.closePopup}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

EmailTempelateList.propTypes = {
  get_email_tempelate_list: PropTypes.func.isRequired,
  testTemplate: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  emailTempelatesList: state.emailReducer.emailTempelatesList,
  mailResponse: state.emailReducer.mailResponse,
  emailTempelateDetails: state.emailReducer.emailTempelateDetails,
});

export default withRouter(connect(mapStateToProps, {
  get_email_tempelate_list,
  renderAlert,
  clearAlert,
  testTemplate,
  get_email_tempelate_details
})(EmailTempelateList));



// WEBPACK FOOTER //
// ./src/app/views/admin/emailTempelate/emailTempelateList.js